import React, { Component } from "react";
import ModalVideo from "react-modal-video";

import "./css/Splash.css";
import "./css/fancy-hover.css";

export default class Splash extends Component {
  state = {
    modalShown: false,
    showImage: true
  };
  toggleModal = () => this.setState({ modalShown: !this.state.modalShown });

  render() {
    return (
      <div className="splash" style={this.props.style}>
        <div>
          {this.state.showImage ? (
            <img
              onLoad={this.props.handleImageLoad}
              draggable={false}
              alt="splash"
              className="splash-image"
              src={
                "https://cdn.battlerite.com/www3/images/static/winter_megapatch/images/DragonLordSplashArtFINALSmall.jpg"
              }
            />
          ) : null}
          <video
            autoPlay
            loop
            muted
            onLoadedData={() => this.setState({ showImage: false })}
          >
            <source
              src="https://cdn.battlerite.com/www3/images/static/adventure/dargons.mp4"
              type="video/mp4"
            />
          </video>
          <div className="images">
            <img
              src="https://cdn.battlerite.com/www3/images/static/winter_megapatch/images/misc/royale_logo.png"
              width="60"
              alt="royale"
            />
            <img
              src="https://cdn.battlerite.com/www3/images/static/logos/logo-small.png"
              width="43"
              alt="arena"
            />
          </div>

          <div className="splash-content">
            <p className="intro">{this.props.intro.toUpperCase()}</p>
            <p className="name">{this.props.name.toUpperCase()}</p>
            <p className="title">{this.props.title.toUpperCase()}</p>
          </div>
          {this.props.video ? (
            <div>
              <div className="playButton" onClick={this.toggleModal}>
                <svg
                  version="1.1"
                  id="play"
                  x="0px"
                  y="0px"
                  height="89px"
                  width="89px"
                  viewBox="0 0 100 100"
                  enableBackground="new 0 0 100 100"
                >
                  <path
                    className="stroke-solid"
                    fill="none"
                    stroke="white"
                    d="M49.9,2.5C23.6,2.8,2.1,24.4,2.5,50.4C2.9,76.5,24.7,98,50.3,97.5c26.4-0.6,47.4-21.8,47.2-47.7
    C97.3,23.7,75.7,2.3,49.9,2.5"
                  />
                  <path
                    className="icon"
                    fill="white"
                    d="M38,69c-1,0.5-1.8,0-1.8-1.1V32.1c0-1.1,0.8-1.6,1.8-1.1l34,18c1,0.5,1,1.4,0,1.9L38,69z"
                  />
                </svg>
              </div>

              <ModalVideo
                channel="youtube"
                isOpen={this.state.modalShown}
                videoId={this.props.video.id}
                onClose={this.toggleModal}
              />
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}
